import { tz } from "@date-fns/tz";
import { endOfDay, endOfMonth, endOfYear, startOfDay, startOfMonth, startOfYear } from "date-fns";
import {
  DateRangePickerViews,
  type IDateRangePickerChip,
  type IDateRangePickerChipDateConfig,
  type IDateRangePickerInnerChip,
} from "../types";

export const calculateDateRangePickerChipDate = (
  config: IDateRangePickerChipDateConfig,
  format: (date: Date) => Date
) => {
  if (typeof config === "function") {
    return format(config());
  }
  return null;
};

export const constructChips = <Chip extends string = string>(
  chips: IDateRangePickerChip<Chip>[],
  view: DateRangePickerViews,
  timeZone: string
) => {
  const tzCtx = { in: tz(timeZone) };
  const innerChips: IDateRangePickerInnerChip<Chip>[] = [];
  const formatStart =
    view === DateRangePickerViews.DAY
      ? (d: Date) => startOfDay(d, tzCtx)
      : view === DateRangePickerViews.MONTH
        ? (d: Date) => startOfMonth(d, tzCtx)
        : (d: Date) => startOfYear(d, tzCtx);
  const formatEnd =
    view === DateRangePickerViews.DAY
      ? (d: Date) => endOfDay(d, tzCtx)
      : view === DateRangePickerViews.MONTH
        ? (d: Date) => endOfMonth(d, tzCtx)
        : (d: Date) => endOfYear(d, tzCtx);
  for (const chip of chips) {
    innerChips.push({
      ...chip,
      startDate: calculateDateRangePickerChipDate(chip.startDate, formatStart),
      endDate: calculateDateRangePickerChipDate(chip.endDate, formatEnd),
    });
  }
  return innerChips;
};
